// Meta tags configuration for category pages
export const categoryMetaTags = {
  packaging: {
    title: "מוצרי אריזה וחומרי אריזה מובילים | RGift",
    description:
      "אצלנו תוכלו למצוא מוצרי אריזה מגוונים לכל מטרה: סרטי משיכה, סרטי קשירה, סרטי סאטן, שקיות צלופן, שקיות יוטה, שקיות נייר, וגלילי נייר לאריזה. צפו בקטלוג המלא >>>",
  },
  electronics: {
    title: "מוצרי אלקטרוניקה ואקססוריז | RGift",
    description:
      "מוצרי אלקטרוניקה איכותיים, אקססוריז ומוצרי טכנולוגיה מתקדמים במחירים משתלמים. גלו את הקטלוג המלא >>>",
  },
  home: {
    title: "אקססוריז לבית ומוצרי עיצוב | RGift",
    description:
      "מבחר עצום של אקססוריז לבית, מוצרי עיצוב, קישוטים ופתרונות עיצוב לכל חדר בבית. עיינו בקטלוג >>>",
  },
  candles: {
    title: "נרות דקורטיביים ומוצרי תאורה | RGift",
    description:
      "נרות דקורטיביים מיוחדים, מוצרי תאורה ואקססוריז לאווירה רומנטית ומיוחדת. גלו את המבחר >>>",
  },
  birthday: {
    title: "מוצרים לימי הולדת וחגיגות | RGift",
    description:
      "כל מה שאתם צריכים לימי הולדת מושלמים: עציצים, נרות, דקורציות ומוצרי חגיגה מיוחדים >>>",
  },
  plants: {
    title: "עציצים מפלסטיק ומוצרי גינה | RGift",
    description:
      "עציצים מפלסטיק איכותיים, מוצרי גינה ודקורציות צמחיה לבית ולמשרד. עמידים וללא תחזוקה >>>",
  },
  favorites: {
    title: "המוצרים המועדפים שלי | RGift",
    description:
      "רשימת המוצרים המועדפים עליכם - שמרו, השוו וקנו את המוצרים שאתם הכי אוהבים",
  },
  // Common variations and alternative slug patterns
  birthdays: {
    title: "מוצרים לימי הולדת וחגיגות | RGift",
    description:
      "כל מה שאתם צריכים לימי הולדת מושלמים: עציצים, נרות, דקורציות ומוצרי חגיגה מיוחדים >>>",
  },
  decorative: {
    title: "מוצרי נוי ודקורציה לבית | RGift",
    description:
      "מוצרי נוי מיוחדים, דקורציות לבית ואקססוריז עיצוב ליצירת אווירה ייחודית בבית >>>",
  },
  decoration: {
    title: "מוצרי נוי ודקורציה לבית | RGift",
    description:
      "מוצרי נוי מיוחדים, דקורציות לבית ואקססוריז עיצוב ליצירת אווירה ייחודית בבית >>>",
  },
  "packaging-materials": {
    title: "מוצרי אריזה וחומרי אריזה מובילים | RGift",
    description:
      "אצלנו תוכלו למצוא מוצרי אריזה מגוונים לכל מטרה: סרטי משיכה, סרטי קשירה, סרטי סאטן, שקיות צלופן, שקיות יוטה, שקיות נייר, וגלילי נייר לאריזה. צפו בקטלוג המלא >>>",
  },
  "home-decor": {
    title: "אקססוריז לבית ומוצרי עיצוב | RGift",
    description:
      "מבחר עצום של אקססוריז לבית, מוצרי עיצוב, קישוטים ופתרונות עיצוב לכל חדר בבית. עיינו בקטלוג >>>",
  },
};

// Default meta tags for the site
export const defaultMetaTags = {
  title: "RGift - חנות אקססוריז לבית ומוצרי עיצוב",
  description:
    "חנות אקססוריז לבית עם מבחר מוצרים: עציצים מפלסטיק, מוצרי אריזה, נרות דקורטיביים ומוצרים לימי הולדת. היכנסו לחנות ובחרו את המוצרים שאתם אוהבים",
};

// Function to get base URL with fallback options
function getBaseUrl() {
  let baseUrl;
  try {
    baseUrl = window.location.origin;
  } catch (e) {
    baseUrl = `${window.location.protocol}//${window.location.host}`;
  }

  // Fallback to production URL only in production environment
  if (!baseUrl || baseUrl === "null") {
    // Check if we're in production
    if (process.env.NODE_ENV === "production") {
      baseUrl = "https://rgift.co.il";
    } else {
      // In development, use localhost with default port
      baseUrl = "http://localhost:8080";
    }
  }

  return baseUrl;
}

// Function to get canonical URL based on current path
/*
export function getCanonicalUrl(customPath = null) {
  const baseUrl = getBaseUrl();

  // If a custom path is provided, use it
  if (customPath) {
    return customPath.startsWith("/")
      ? `${baseUrl}${customPath}`
      : `${baseUrl}/${customPath}`;
  }

  // Otherwise, use the current window location pathname
  try {
    const currentPath = window.location.pathname;
    return `${baseUrl}${currentPath}`;
  } catch (e) {
    // Fallback to base URL if window.location is not available
    return baseUrl;
  }
}
*/

// Function to get canonical URL based on current path
export function getCanonicalUrl(customPath = null) {
  const baseUrl = getBaseUrl();

  // If a custom path is provided, use it
  if (customPath) {
    return customPath.startsWith("/")
      ? `${baseUrl}${customPath}`
      : `${baseUrl}/${customPath}`;
  }

  // Otherwise, use the current window location pathname + query string
  try {
    const currentPath = window.location.pathname;
    const queryString = window.location.search; // Gets ?category=bath-sets etc.
    const fullUrl = `${baseUrl}${currentPath}${queryString}`;

    return fullUrl;
  } catch (e) {
    // Fallback to base URL if window.location is not available
    console.error("Error generating canonical URL:", e);
    return baseUrl;
  }
}

// Function to update meta tags in the DOM
export function updateMetaTags(
  title,
  description,
  canonicalUrl = null,
  includeCanonical = true,
) {
  // Update title
  document.title = title;

  // Update meta description
  let metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute("content", description);
  } else {
    metaDescription = document.createElement("meta");
    metaDescription.setAttribute("name", "description");
    metaDescription.setAttribute("content", description);
    document.head.appendChild(metaDescription);
  }

  // Update canonical URL - use provided URL or generate from current path
  //Only update canonical if flag is true
  if (includeCanonical) {
    const finalCanonicalUrl = canonicalUrl || getCanonicalUrl();
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute("href", finalCanonicalUrl);
    } else {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", finalCanonicalUrl);
      document.head.appendChild(canonicalLink);
    }
  } else {
    // Remove canonical if it exists and includeCanonical is false
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
  }
}

// Function to get meta tags for a specific category
export function getMetaTagsForCategory(categoryPath) {
  // Debug: Log the category path and available keys
  // console.log("Category Path:", categoryPath);
  // console.log("Available category keys:", Object.keys(categoryMetaTags));
  // console.log("Direct match found:", !!categoryMetaTags[categoryPath]);

  // Check if we have specific meta tags for this category
  if (categoryPath && categoryMetaTags[categoryPath]) {
    const categoryMeta = categoryMetaTags[categoryPath];
    // console.log("Using configured meta tags for:", categoryPath);
    return {
      title: categoryMeta.title,
      description: categoryMeta.description,
      canonicalUrl: getCanonicalUrl(),
    };
  }

  // If category not found in our config, create generic meta tags
  if (categoryPath && categoryPath !== "favorites") {
    // For unconfigured categories, create generic Hebrew meta tags
    console.log("No specific meta tags found for category:");
    console.log("Using generic meta tags for:", categoryPath);
    return {
      title: `מוצרי ${categoryPath} | RGift`,
      description: `מבחר מוצרי ${categoryPath} איכותיים במחירים משתלמים. עיינו בקטלוג המלא וקנו בקלות אונליין >>>`,
      canonicalUrl: getCanonicalUrl(),
    };
  }

  // Return default meta tags if category not found or empty
  console.log("Using default meta tags");
  return {
    title: defaultMetaTags.title,
    description: defaultMetaTags.description,
    canonicalUrl: getCanonicalUrl(),
  };
}

// Function to get meta tags for products page
export function getMetaTagsForProducts() {
  return {
    title:
      "rgift | מוצרי נוי, אגרטלים, עצי פלסטיק מעוצבים, מוצרים לימי הולדת ואריזות בסטייל",
    description:
      "חנות אקססוריז לבית עם מבחר מוצרים: עציצים מפלסטיק, מוצרי אריזה, נרות דקורטיביים ומוצרים לימי הולדת. היכנסו לחנות ובחרו את המוצרים שאתם אוהבים",
    canonicalUrl: getCanonicalUrl(),
  };
}

// Async function to get meta tags for category pages by fetching from API
export async function getMetaTagsForCategoryFromAPI(
  store,
  rootCategorySlug,
  subCategorySlug = null,
) {
  try {
    let categoryData = null;

    if (subCategorySlug) {
      // If there's a subCategory, fetch sub-categories from API
      const categoriesResponse = await store.dispatch(
        "Category/getCategories",
        {
          rootCategory: rootCategorySlug,
        },
      );

      // Find the specific sub-category that matches our slug
      if (categoriesResponse && categoriesResponse.data) {
        categoryData = categoriesResponse.data.find(
          (cat) => cat.slug === subCategorySlug,
        );

        // Map the fields to match our expected structure
        if (categoryData) {
          categoryData = {
            title: categoryData.categoryName,
            metaTitle: categoryData.metaTitle,
            metaDescription: categoryData.metaDescription,
          };
        } else {
          console.log("⚠️ Subcategory not found in response");
        }
      }
    } else {
      // If no subCategory, get root category data from store
      let rootCategories = store.getters["Category/getRootCategories"];

      // If root categories not loaded yet, load them
      if (!rootCategories || rootCategories.length === 0) {
        await store.dispatch("Category/getRootCategories");
        rootCategories = store.getters["Category/getRootCategories"];
      }

      // Find the root category
      categoryData = rootCategories.find(
        (cat) => cat.path === rootCategorySlug,
      );
    }

    // If we found category data, use it (with fallbacks for missing meta fields)
    if (categoryData) {
      const categorySlug = subCategorySlug || rootCategorySlug;
      const fallbackMeta = getMetaTagsForCategory(categorySlug);
      // For subcategories, use categoryName from backend if metaTitle is not set
      const fallbackTitle = categoryData.title
        ? `מוצרי ${categoryData.title} | RGift`
        : fallbackMeta.title;

      const fallbackDescription = categoryData.title
        ? `מבחר מוצרי ${categoryData.title} איכותיים במחירים משתלמים. עיינו בקטלוג המלא וקנו בקלות אונליין >>>`
        : fallbackMeta.description;

      const finalMetaTags = {
        title: categoryData.metaTitle || fallbackTitle,
        description: categoryData.metaDescription || fallbackDescription,
        canonicalUrl: getCanonicalUrl(),
      };

      return finalMetaTags;
    } else {
      // Fallback to hardcoded meta tags if category data not found
      const categorySlug = subCategorySlug || rootCategorySlug;
      const fallbackMeta = getMetaTagsForCategory(categorySlug);

      return fallbackMeta;
    }
  } catch (error) {
    // Fallback to hardcoded meta tags on error
    const categorySlug = subCategorySlug || rootCategorySlug;
    const fallbackMeta = getMetaTagsForCategory(categorySlug);

    return fallbackMeta;
  }
}

export async function getMetaTagsForProduct(
  store,
  productId,
  rootCategorySlug,
  subCategorySlug,
) {
  try {
    const productResponse = await store.dispatch("Parts/findParts", {
      id: productId,
    });

    if (!productResponse?.parts || productResponse.parts.length === 0) {
      return await getMetaTagsForCategoryFromAPI(
        store,
        rootCategorySlug,
        subCategorySlug,
      );
    }

    const product = productResponse.parts[0];

    // ✅ Get the category/fallback meta tags first
    // const categoryMeta = await getMetaTagsForCategoryFromAPI(
    //   store,
    //   rootCategorySlug,
    //   subCategorySlug,
    // );

    // ✅ Use default title if there isnt one in the part level
    let title = `rgift | ${product.name} `; // Default title format

    // ✅ Only override if partMetaTitle exists and not empty
    if (product.partMetaTitle && product.partMetaTitle.trim()) {
      title = product.partMetaTitle;
    }

    let description;
    if (product.partMetaDescription && product.partMetaDescription.trim()) {
      // Priority 1: Use partMetaDescription if it exists
      description = product.partMetaDescription;
    } else if (product.description && product.description.trim()) {
      // Priority 2: Use description but strip HTML tags
      // Remove all HTML tags and decode HTML entities
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = product.description;
      description = tempDiv.textContent || tempDiv.innerText || "";

      // Trim and remove extra whitespace
      description = description.trim().replace(/\s+/g, " ");

      // ✅ Limit to 150 characters and add ellipsis if needed
      if (description.length > 150) {
        description = description.substring(0, 150) + "...";
      }
    } else {
      // Priority 3: leave blank
      description = "";
    }

    const canonicalUrl = `${getBaseUrl()}/products/${productId}`;

    // Inject Product JSON-LD schema
    injectProductSchema(product);

    return { title, description, canonicalUrl };
  } catch (error) {
    console.error("❌ Error fetching product meta tags:", error);
    return await getMetaTagsForCategoryFromAPI(
      store,
      rootCategorySlug,
      subCategorySlug,
    );
  }
}

// Function to build full image URL for schema
function getFullImageUrl(imagePath) {
  if (!imagePath) return null;
  if (imagePath.startsWith("http")) return imagePath;
  return `https://rgift.co.il/api${imagePath}`;
}

// Function to inject Product JSON-LD schema into the DOM
export function injectProductSchema(product) {
  // Remove any existing product schema
  removeProductSchema();

  const baseUrl = getBaseUrl();
  const productUrl = `${baseUrl}/products/${product.part || product.id}`;

  // Build images array
  const images = [];
  if (product.image) {
    images.push(getFullImageUrl(product.image));
  }
  if (product.PartImages && product.PartImages.length) {
    product.PartImages.forEach((img) => {
      const url = getFullImageUrl(img.image || img);
      if (url) images.push(url);
    });
  }

  // Strip HTML from description
  let description = "";
  if (product.partMetaDescription && product.partMetaDescription.trim()) {
    description = product.partMetaDescription.trim();
  } else if (product.description && product.description.trim()) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = product.description;
    description = (tempDiv.textContent || tempDiv.innerText || "").trim().replace(/\s+/g, " ");
    if (description.length > 200) {
      description = description.substring(0, 200) + "...";
    }
  }

  // Determine price - use originPrice as base, discountPrice only if it's a real discount (> 0)
  const price = (product.discountPrice && product.discountPrice > 0)
    ? product.discountPrice
    : (product.originPrice || 0);

  // Determine availability
  const availability = product.AvailableInStock
    ? "https://schema.org/InStock"
    : "https://schema.org/OutOfStock";

  // Dynamic priceValidUntil - 1 year from now
  const validUntil = new Date();
  validUntil.setFullYear(validUntil.getFullYear() + 1);
  const priceValidUntil = validUntil.toISOString().split("T")[0];

  const schema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": product.name,
    "image": images.length ? images : undefined,
    "brand": {
      "@type": "Brand",
      "name": "RGift",
    },
    "offers": {
      "@type": "Offer",
      "url": productUrl,
      "priceCurrency": "ILS",
      "price": String(price),
      "priceValidUntil": priceValidUntil,
      "itemCondition": "https://schema.org/NewCondition",
      "availability": availability,
    },
  };

  // Add optional fields only if they have values
  if (description) {
    schema.description = description;
  }
  if (product.sku) {
    schema.sku = product.sku;
    // If SKU looks like a GTIN-13 (EAN-13 barcode), add it as gtin13
    if (/^\d{13}$/.test(product.sku)) {
      schema.gtin13 = product.sku;
    }
  }

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = "product-schema-jsonld";
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
}

// Function to remove Product JSON-LD schema from the DOM
export function removeProductSchema() {
  const existing = document.getElementById("product-schema-jsonld");
  if (existing) {
    existing.remove();
  }
}

// Generic function to get meta tags for any route
export function getMetaTagsForRoute(
  title = null,
  description = null,
  customPath = null,
) {
  return {
    title: title || defaultMetaTags.title,
    description: description || defaultMetaTags.description,
    canonicalUrl: getCanonicalUrl(customPath),
  };
}
